/** Reserved chat geometry while route code or persisted messages are loading. */
export function LexChatLoadingState({ label = 'Opening Lex…' }: { label?: string }) {
  return (
    <div className="flex min-h-0 flex-1 flex-col overflow-hidden bg-[var(--lex-chat-canvas)] px-6 pt-9" role="status" aria-live="polite" aria-busy="true">
      <div className="mx-auto w-full max-w-3xl">
        <p className="h-8 text-center text-sm text-[var(--lex-text-secondary)]">{label}</p>
        <div aria-hidden="true" className="mt-5 h-40 rounded-xl border border-[var(--lex-border)] bg-[var(--lex-surface-card)]" />
        <div aria-hidden="true" className="mt-5 grid gap-2 md:grid-cols-3">
          {[0, 1, 2].map((item) => <div key={item} className="h-[84px] rounded-lg border border-[var(--lex-border)] bg-[var(--lex-surface-card)]" />)}
        </div>
      </div>
    </div>
  );
}
